import NestedTypes from "backbone.nestedtypes";

export default NestedTypes.Model.extend({
    sync: function () {},
});
